export enum ETableMappedFilter {
  ALL = 'ALL',
  Unmapped = 'Unmapped',
  Mapped = 'Mapped',
}

export enum ETableDeployedFilter {
  ALL = 'ALL',
  Undeployed = 'Undeployed',
  Deployed = 'Deployed',
}

export enum ETablePredefinedFilter {
  ALL = 'ALL',
  Predefined = 'Predefined',
  Custom = 'Custom',
}

export enum EDimensionListFilter {
  ALL = 'ALL',
  System = 'System',
  Custom = 'Custom',
}

export type TTableFilter =
  | ETableMappedFilter
  | ETableDeployedFilter
  | ETablePredefinedFilter
  | EDimensionListFilter;

export type TableFilter = 'Mapped' | 'Deployed' | 'Predefined' | 'Dimension_List';

export interface ITableSubHeader {
  type?: TableFilter;
  onClick?: (value: TTableFilter) => void;
  showSearch?: boolean;
  onSearchClick?: () => void;
}
